import { render } from "./EmptyOrders.vue?vue&type=template&id=6a83a386"
import script from "./EmptyOrders.vue?vue&type=script&lang=js"
export * from "./EmptyOrders.vue?vue&type=script&lang=js"

import "./EmptyOrders.vue?vue&type=style&index=0&id=6a83a386&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__